import { cn } from "@/utils";
import type { SVGProps } from "react";

export default function EighteenIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
      {...props}
    >
      <path
        d="M18 14.667C18 14.4618 17.7307 14 17 14C16.2693 14 16 14.4618 16 14.667V16.333C16 16.5382 16.2693 17 17 17C17.7307 17 18 16.5382 18 16.333V14.667ZM20 16.333C20 17.9687 18.4784 19 17 19C15.5216 19 14 17.9687 14 16.333V14.667C14 13.0313 15.5216 12 17 12C18.4784 12 20 13.0313 20 14.667V16.333Z"
        fill="currentColor"
      />
      <path
        d="M18 9.66699C18 9.46177 17.7307 9 17 9C16.2693 9 16 9.46177 16 9.66699V11.333C16 11.5382 16.2693 12 17 12C17.7307 12 18 11.5382 18 11.333V9.66699ZM20 11.333C20 12.9687 18.4784 14 17 14C15.5216 14 14 12.9687 14 11.333V9.66699C14 8.03126 15.5216 7 17 7C18.4784 7 20 8.03126 20 9.66699V11.333Z"
        fill="currentColor"
      />
      <path
        d="M8 18V9H7C6.44772 9 6 8.55228 6 8C6 7.44772 6.44772 7 7 7H9L9.10254 7.00488C9.60667 7.05621 10 7.48232 10 8V18C10 18.5523 9.55228 19 9 19C8.44772 19 8 18.5523 8 18Z"
        fill="currentColor"
      />
      <path
        d="M11 17C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H7C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17H11Z"
        fill="currentColor"
      />
      <path
        d="M24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24C19.0751 24 24 19.0751 24 13ZM26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
        fill="currentColor"
      />
    </svg>
  );
}
